// // services/apiServiceSingleton.js
// import axios from "axios";

// // const API_BASE_URL = "http://127.0.0.1:8000/api/";
// // const BASE_IMAGE_URL = "http://127.0.0.1:8000/";

// const API_BASE_URL = "https://www.anuradhaartjewellery.com/api/";
// const BASE_IMAGE_URL = "https://www.anuradhaartjewellery.com/";

// // Axios instance
// const api = axios.create({
//   // baseURL: API_BASE_URL,
//   baseURL: process.env.REACT_APP_BACKEND_API,

//   headers: { Accept: "application/json" },
// });

// // Interceptor for token auth
// api.interceptors.request.use((config) => {
//   const token = localStorage.getItem("token");
//   if (token) config.headers.Authorization = `Bearer ${token}`;

//   return config;
// });

// export const apiServiceSingleton = {
//   BASE_IMAGE_URL,

//   get: (endpoint) => api.get(endpoint),

//   update: (endpoint, data) => api.put(endpoint, data),

//   updateWithFile: (endpoint, data) => {
//     const formData = new FormData();
//     for (let key in data) {
//       if (data[key] !== null && data[key] !== undefined) {
//         formData.append(key, data[key]);
//       }
//     }
//     // Laravel style method spoofing for PUT with multipart/form-data
//     formData.append("_method", "PUT");

//     return api.post(endpoint, formData, {
//       headers: { "Content-Type": "multipart/form-data" },
//     });
//   },
// };

// services/apiServiceSingleton.js
import axios from "axios";

// const API_BASE_URL = "http://127.0.0.1:8000/api/";
// const BASE_IMAGE_URL = "http://127.0.0.1:8000/"; 

const API_BASE_URL = "https://roles.vitaura.co.in/mart/api/";
const BASE_IMAGE_URL = "https://roles.vitaura.co.in/mart/";

// const API_BASE_URL = "https://gdrbfashion.axylotech.com/api/";
// const BASE_IMAGE_URL = "https://gdrbfashion.axylotech.com/";

// Axios instance
const api = axios.create({
  // baseURL: API_BASE_URL,
  baseURL: process.env.REACT_APP_BACKEND_API,

  headers: { Accept: "application/json" },
});

// Interceptor for token auth
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;

  return config;
});

export const apiServiceSingleton = {
  BASE_IMAGE_URL,

  get: (endpoint) => api.get(endpoint),

  update: (endpoint, data) => api.put(endpoint, data),

  updateWithFile: (endpoint, data) => {
    const formData = new FormData();
    for (let key in data) {
      if (data[key] !== null && data[key] !== undefined) {
        formData.append(key, data[key]);
      }
    }
    // Laravel style method spoofing for PUT with multipart/form-data
    formData.append("_method", "PUT");

    return api.post(endpoint, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
};